'use client'
import { useSnackbar } from '@/contexts/SnackbarContext'
import Script from 'next/script'
import React from 'react'

const Form = () => {
    // const { showSnackbar } = useSnackbar()
    // const handleFormSubmit = (e: any) => {
    //     e.preventDefault()
    //     const form = document.getElementById('vending-form') as HTMLFormElement
    //     const formData = new FormData(form)
    //     const xhr = new XMLHttpRequest()
    //     xhr.open('POST', form.action, true)
    //     xhr.setRequestHeader('Accept', 'application/json')
    //     xhr.onreadystatechange = () => {
    //         if (xhr.readyState !== XMLHttpRequest.DONE) return
    //         if (xhr.status === 200) {
    //             form.reset()
    //             showSnackbar(3000, 0, 'Your message has been sent successfully.')
    //         } else {
    //             showSnackbar(3000, 1, 'An error occurred. Please try again later.')
    //         }
    //     }
    //     xhr.send(formData)
    // }
    return (
        <section id="form-v" className='pt-4'>
            <h1 className="title-v w-full text-center">
                Get in touch with us
            </h1>
            <br />

            <form encType='application/x-www-form-urlencoded' id="vending-form" method="post" role="form"
                action="https://svc.chaivio.com/api/contact/vending" className='w-full p-4'>
                <div className="form-info-v">
                    <div className="form-element-v">
                        <label htmlFor="name-v">*Name:</label>
                        <input id="name-v" required name="name" type="text" autoComplete="name" />
                    </div>
                    <div style={{
                        display: 'none'
                    }}>
                        <label htmlFor="subject-v">*subject:</label>
                        <input id="subject-v" required value={"Vending"} readOnly name="subject" type="text" autoComplete="name" />
                    </div>
                    <div className="form-element-v">
                        <label htmlFor="business-name">*Business Name:</label>
                        <input id="business-name" name="businessname" type="text" required
                            autoComplete="organization-title" />
                    </div>
                    <div className="form-element-v">
                        <label htmlFor="email-v">*Email:</label>
                        <input id="email-v" name="fromEmail" type="email" autoComplete="email" required />
                    </div>
                    <div className="form-element-v">
                        <label htmlFor="phone-v">*Phone Number:</label>
                        <input id="phone-v" name="phoneno" required autoComplete="tel" type="tel" />
                    </div>

                </div>
                <div className="form-element-v form-v-textarea">
                    <label htmlFor="msg-v">*Tell Us About Your Business:</label>
                    <textarea id="msg-v" name="message" required rows={6}></textarea>
                </div>
                <div
                    data-sitekey="0x4AAAAAAA7sG85pku3o0m-I"
                    id="turnstile-widget" className="cf-turnstile w-full"
                ></div>
                <button className="g-recaptcha btn dark submit-v" style={{ width: 'auto' }}
                    type='submit'
                >Submit</button>
            </form>
            <Script
                src="https://challenges.cloudflare.com/turnstile/v0/api.js"
                async
                defer
            />
        </section>
    )
}

export default Form